/** Client-side demo fixtures — used when VITE_DEMO_MODE=true or API unavailable. */

export const DEMO_MODE = import.meta.env.VITE_DEMO_MODE !== "false";

export const DEMO_SUBSCRIBERS = [
  { id: "d1", email: "nadia.hassan@gmail.com", clevertap_identity: "ct_88421", newsletter_opt_in: true, country: "EG", locale: "ar", synced_at: "2026-08-11T06:00:00Z", member_type: "patient", last_active: "2026-08-24T10:00:00Z", interests: ["Nutrition", "Women's health"], last_received: "2026-08-04T08:05:00Z", last_opened: "2026-08-04T09:12:00Z", last_clicked: "2026-08-04T09:14:00Z", unsubscribed_from: null as string | null },
  { id: "d2", email: "omar.khalil@outlook.com", clevertap_identity: "ct_88422", newsletter_opt_in: true, country: "SA", locale: "ar", synced_at: "2026-08-11T06:00:00Z", member_type: "patient", last_active: "2026-08-20T08:00:00Z", interests: ["Heart Health"], last_received: "2026-08-04T08:05:00Z", last_opened: "2026-08-04T18:01:00Z", last_clicked: null as string | null, unsubscribed_from: null as string | null },
  { id: "d3", email: "layla.m@yahoo.com", clevertap_identity: "ct_88423", newsletter_opt_in: true, country: "JO", locale: "ar", synced_at: "2026-08-11T06:00:00Z", member_type: "patient", last_active: "2026-08-25T16:20:00Z", interests: ["Nutrition", "Weight Loss"], last_received: "2026-08-04T08:05:00Z", last_opened: "2026-08-05T07:40:00Z", last_clicked: "2026-08-05T07:41:00Z", unsubscribed_from: null as string | null },
  { id: "d4", email: "fatima.alami@gmail.com", clevertap_identity: "ct_88424", newsletter_opt_in: false, country: "MA", locale: "ar", synced_at: "2026-08-11T06:00:00Z", member_type: "patient", last_active: "2026-07-02T12:00:00Z", interests: ["Nutrition"], last_received: "2026-06-12T08:00:00Z", last_opened: null as string | null, last_clicked: null as string | null, unsubscribed_from: "Weekly digest" },
  { id: "d5", email: "youssef.ibrahim@hotmail.com", clevertap_identity: "ct_88425", newsletter_opt_in: true, country: "EG", locale: "ar", synced_at: "2026-08-11T06:00:00Z", member_type: "doctor", last_active: "2026-08-22T11:00:00Z", interests: ["Heart Health", "Diabetes"], last_received: "2026-08-04T08:05:00Z", last_opened: "2026-08-04T08:40:00Z", last_clicked: null as string | null, unsubscribed_from: null as string | null },
  { id: "d6", email: "sara.jazzar@altibbi.com", clevertap_identity: "ct_88426", newsletter_opt_in: true, country: "JO", locale: "ar", synced_at: "2026-08-11T06:00:00Z", member_type: "staff", last_active: "2026-08-26T07:00:00Z", interests: ["Nutrition", "Heart Health"], last_received: "2026-08-04T08:05:00Z", last_opened: "2026-08-04T08:10:00Z", last_clicked: "2026-08-04T08:11:00Z", unsubscribed_from: null as string | null },
  { id: "d7", email: "ahmed.maher@altibbi.com", clevertap_identity: "ct_88427", newsletter_opt_in: true, country: "JO", locale: "ar", synced_at: "2026-08-11T06:00:00Z", member_type: "staff", last_active: "2026-08-25T09:00:00Z", interests: ["Diabetes"], last_received: "2026-08-04T08:05:00Z", last_opened: null as string | null, last_clicked: null as string | null, unsubscribed_from: null as string | null },
  { id: "d8", email: "mariam.said@gmail.com", clevertap_identity: "ct_88428", newsletter_opt_in: true, country: "IQ", locale: "ar", synced_at: "2026-08-10T06:00:00Z", member_type: "patient", last_active: "2026-08-18T14:00:00Z", interests: ["Women's health"], last_received: "2026-07-28T08:02:00Z", last_opened: "2026-07-28T20:00:00Z", last_clicked: null as string | null, unsubscribed_from: null as string | null },
  { id: "d9", email: "khaled.nasser@proton.me", clevertap_identity: "ct_88429", newsletter_opt_in: null, country: "AE", locale: "ar", synced_at: "2026-08-10T06:00:00Z", member_type: "patient", last_active: "2026-08-01T08:00:00Z", interests: [] as string[], last_received: null as string | null, last_opened: null as string | null, last_clicked: null as string | null, unsubscribed_from: null as string | null },
  { id: "d10", email: "rana.fares@gmail.com", clevertap_identity: "ct_88430", newsletter_opt_in: true, country: "LB", locale: "ar", synced_at: "2026-08-10T06:00:00Z", member_type: "patient", last_active: "2026-08-19T19:00:00Z", interests: ["Weight Loss", "Nutrition"], last_received: "2026-08-04T08:05:00Z", last_opened: "2026-08-04T12:22:00Z", last_clicked: "2026-08-04T12:23:00Z", unsubscribed_from: null as string | null },
  { id: "d11", email: "huda.w@icloud.com", clevertap_identity: "ct_88431", newsletter_opt_in: true, country: "SA", locale: "ar", synced_at: "2026-08-09T06:00:00Z", member_type: "patient", last_active: "2026-08-21T06:00:00Z", interests: ["Heart Health"], last_received: "2026-07-28T08:02:00Z", last_opened: "2026-07-29T09:00:00Z", last_clicked: null as string | null, unsubscribed_from: null as string | null },
  { id: "d12", email: "tariq.omar@gmail.com", clevertap_identity: "ct_88432", newsletter_opt_in: false, country: "DZ", locale: "ar", synced_at: "2026-08-09T06:00:00Z", member_type: "patient", last_active: "2026-06-11T10:00:00Z", interests: ["Diabetes"], last_received: "2026-05-20T08:00:00Z", last_opened: null as string | null, last_clicked: null as string | null, unsubscribed_from: "Gulf digest" },
];

export const DEMO_SYNC = {
  source: "clevertap_profiles",
  last_run_at: "2026-08-11T06:15:00Z",
  last_success: "2026-08-11T06:14:32Z",
  rows_loaded: 248_391,
  error: null as string | null,
};

export const DEMO_PIPELINE = {
  last_sync_at: "2026-08-17T12:40:00Z",
  last_sync_success: "2026-08-17T12:40:12Z",
  last_sync_error: null as string | null,
  profiles: 10217,
  consent_missing: 10213,
  consent_granted: 4,
  explicit_interest: 136,
  queued: 0,
  sent: 0,
  failed: 0,
  blocked: 0,
  suppressed: 12,
  profile_events: 284_102,
  cio_waiting: 42,
  cio_active: 8_204,
  cio_removed: 1_891,
  monthly_sent: 0,
  monthly_cap: 5_000_000,
  send_controls_enabled: false,
};

export const DEMO_OVERVIEW = {
  total_subscribers: 248_391,
  opted_in: 186_204,
  opted_in_pct: 75.0,
  subscriber_delta_pct: 0.032,
  opted_in_delta_pct: 0.012,
  open_rate_delta_pct: 0.018,
  countries_top: [
    { country: "EG", count: 98234, share: 39.5 },
    { country: "SA", count: 54102, share: 21.8 },
    { country: "JO", count: 31887, share: 12.8 },
  ],
  last_issue: "Weekly health digest — 4 Aug 2026",
  last_issue_open_rate: 24.2,
  last_send_recipients: 184_102,
};

export const DEMO_SEND_TREND = [
  { date: "2026-07-07", open_rate: 22.1 },
  { date: "2026-07-14", open_rate: 21.5 },
  { date: "2026-07-21", open_rate: 23.0 },
  { date: "2026-07-28", open_rate: 21.8 },
  { date: "2026-08-04", open_rate: 24.2 },
  { date: "2026-08-11", open_rate: 24.6 },
];

export const COUNTRY_NAMES: Record<string, string> = {
  EG: "Egypt",
  SA: "Saudi Arabia",
  JO: "Jordan",
  MA: "Morocco",
  IQ: "Iraq",
  AE: "UAE",
  LB: "Lebanon",
  DZ: "Algeria",
  KW: "Kuwait",
};

export const COUNTRY_COLORS = ["var(--c-accent)", "var(--c-purple)", "var(--c-teal)", "var(--c-warn)", "var(--c-success)"];

export const DEMO_SEGMENTS = [
  {
    id: "s1", name: "Weekly digest — opted in",
    description: "Core weekly audience — newsletter opt-in with recent activity",
    member_count: 186_204, last_pushed_at: "2026-08-11T05:00:00Z", updated_at: "2026-08-26T07:52:00Z", status: "synced" as const,
    tags: ["core", "weekly"],
    used_in_campaigns: 12,
    rules: [
      { field: "newsletter_opt_in", op: "equals", value: "true" },
      { field: "last_active", op: "within", value: "90 days" },
    ],
  },
  {
    id: "s6", name: "Nutrition — Jordan",
    description: "Jordan subscribers in the Nutrition category",
    member_count: 84_231, last_pushed_at: "2026-08-26T07:50:00Z", updated_at: "2026-08-26T08:01:00Z", status: "synced" as const,
    tags: ["jordan", "nutrition"],
    used_in_campaigns: 2,
    rules: [
      { field: "country", op: "equals", value: "Jordan" },
      { field: "category", op: "equals", value: "Nutrition" },
      { field: "newsletter_opt_in", op: "equals", value: "true" },
    ],
  },
  {
    id: "s7", name: "Nutrition + Weight Loss",
    description: "People in Nutrition or Weight Loss — unique audience, not a sum",
    member_count: 165_000, last_pushed_at: "2026-08-25T12:00:00Z", updated_at: "2026-08-26T07:40:00Z", status: "synced" as const,
    tags: ["nutrition", "weight-loss"],
    used_in_campaigns: 0,
    match: "any" as const,
    rules: [
      { field: "category", op: "equals", value: "Nutrition" },
      { field: "category", op: "equals", value: "Weight Loss" },
      { field: "newsletter_opt_in", op: "equals", value: "true" },
    ],
  },
  {
    id: "s8", name: "Diabetes — Jordan",
    description: "No matching subscribers with current filters",
    member_count: 0, last_pushed_at: null, updated_at: "2026-08-26T07:10:00Z", status: "draft" as const,
    tags: ["diabetes"],
    used_in_campaigns: 0,
    rules: [
      { field: "country", op: "equals", value: "Jordan" },
      { field: "category", op: "equals", value: "Diabetes" },
    ],
  },
  {
    id: "s9", name: "Nutrition",
    description: "All Nutrition-category subscribers across markets",
    member_count: 1_284_231, last_pushed_at: "2026-08-24T05:00:00Z", updated_at: "2026-08-26T06:00:00Z", status: "synced" as const,
    tags: ["nutrition", "broad"],
    used_in_campaigns: 1,
    rules: [
      { field: "category", op: "equals", value: "Nutrition" },
    ],
  },
  {
    id: "s2", name: "Egypt — women's health",
    description: "Egypt subscribers with women's health content affinity",
    member_count: 42_881, last_pushed_at: "2026-08-10T05:00:00Z", updated_at: "2026-08-10T05:00:00Z", status: "synced" as const,
    tags: ["egypt", "vertical"],
    used_in_campaigns: 4,
    rules: [
      { field: "country", op: "equals", value: "EG" },
      { field: "category", op: "contains", value: "women's health" },
    ],
  },
  {
    id: "s3", name: "Gulf — Arabic digest",
    description: "Gulf countries, Arabic locale, opted-in subscribers",
    member_count: 67_330, last_pushed_at: "2026-08-09T05:00:00Z", updated_at: "2026-08-09T05:00:00Z", status: "synced" as const,
    tags: ["gulf", "arabic"],
    used_in_campaigns: 6,
    rules: [
      { field: "country", op: "in", value: "SA, AE, KW, QA, BH, OM" },
      { field: "locale", op: "equals", value: "ar" },
    ],
  },
  {
    id: "s4", name: "Re-engagement 90d inactive",
    description: "Opted in but haven't opened a newsletter in 90 days",
    member_count: 31_442, last_pushed_at: null, updated_at: "2026-08-11T15:00:00Z", status: "draft" as const,
    tags: ["re-engagement"],
    used_in_campaigns: 0,
    rules: [
      { field: "newsletter_opt_in", op: "equals", value: "true" },
      { field: "last_active", op: "within", value: "90 days" },
    ],
  },
  {
    id: "s5", name: "New subscribers — last 7 days",
    description: "Fresh profiles synced in the rolling 7-day window",
    member_count: 3_218, last_pushed_at: "2026-08-11T05:00:00Z", updated_at: "2026-08-11T05:00:00Z", status: "synced" as const,
    tags: ["onboarding", "new"],
    used_in_campaigns: 1,
    rules: [
      { field: "last_active", op: "within", value: "7 days" },
      { field: "newsletter_opt_in", op: "equals", value: "true" },
    ],
  },
];

export const DEMO_ISSUES = [
  {
    id: "i1", title: "Weekly health digest", subject: "أبرز مقالات Altibbi هذا الأسبوع",
    status: "sent" as const, updated_at: "2026-08-04T14:00:00Z", author: "Lina A.", articles: 5, open_rate: 24.2,
    articles_list: [
      { title: "استخدامات بودرة التلك وأضرارها", url: "https://altibbi.com/مقالات-طبية/كيمياء/بودرة-التلك-استخدامات-بودرة-التلك-ومضارها-4849", category: "Dermatology" },
      { title: "فوائد فيتامين D للأطفال", url: "https://altibbi.com/مقالات-طبية/", category: "Pediatrics" },
      { title: "أعراض نقص الحديد عند النساء", url: "https://altibbi.com/مقالات-طبية/", category: "Women's health" },
    ],
    notes: "Strong open rate — repeat format next week.",
    reviewer: "Dr. Sami",
  },
  {
    id: "i2", title: "صيف 2026 — نصائح الترطيب", subject: "كيف تحمي بشرتك من الشمس؟",
    status: "approved" as const, updated_at: "2026-08-10T11:30:00Z", author: "Karim M.", articles: 3, open_rate: null as number | null,
    articles_list: [
      { title: "حماية البشرة من أشعة الشمس", url: "https://altibbi.com/مقالات-طبية/", category: "Dermatology" },
      { title: "الترطيب في الصيف", url: "https://altibbi.com/مقالات-طبية/", category: "Skincare" },
    ],
    notes: "Approved — schedule for 14 Aug with weekly digest segment.",
    reviewer: "Nour H.",
    next_action: "Schedule campaign",
    preheader: "Summer skin care from Altibbi",
    sender_name: "Altibbi",
    reply_to: "newsletter@altibbi.me",
    utm: { source: "altibbi-newsletter", medium: "email", campaign: "summer-skincare-2026" },
    blocks: [
      { id: "b-i2-h", type: "heading" as const, text: "صيف 2026 — نصائح الترطيب" },
      { id: "b-i2-t", type: "text" as const, text: "مرحباً {{first_name}} — نصائح هذا الأسبوع لحماية بشرتك." },
      { id: "b-i2-a", type: "article" as const, text: "حماية البشرة من أشعة الشمس", url: "https://altibbi.com/مقالات-طبية/", alt: "Dermatology" },
      { id: "b-i2-f", type: "footer" as const, text: "You received this because you subscribed to Altibbi newsletters. Unsubscribe at https://altibbi.com/unsubscribe" },
    ],
    versions: [
      {
        id: "v-i2-1", n: 1, status: "in_review" as const, at: "2026-08-10T09:42:00Z",
        actor: "Karim M.", title: "صيف 2026 — نصائح الترطيب", subject: "كيف تحمي بشرتك من الشمس؟",
        blocks: [], notes: "Submitted for editorial review.",
      },
      {
        id: "v-i2-2", n: 2, status: "approved" as const, at: "2026-08-10T11:30:00Z",
        actor: "Nour H.", title: "صيف 2026 — نصائح الترطيب", subject: "كيف تحمي بشرتك من الشمس؟",
        blocks: [], notes: "Approved — schedule for 14 Aug with weekly digest segment.",
      },
    ],
  },
  {
    id: "i3", title: "Women's health focus", subject: "موضوعات صحة المرأة",
    status: "in_review" as const, updated_at: "2026-08-11T09:00:00Z", author: "Nour H.", articles: 4, open_rate: null,
    articles_list: [
      { title: "أعراض نقص الحديد عند النساء", url: "https://altibbi.com/مقالات-طبية/", category: "Women's health" },
      { title: "التحضير للحمل", url: "https://altibbi.com/مقالات-طبية/", category: "Pregnancy" },
    ],
    notes: "Subject line needs medical review before approval.",
    reviewer: "Dr. Sami",
    next_action: "Approve subject line",
    comments: [
      {
        id: "ec1",
        text: "Please change the subject line and add an image after the second paragraph.",
        author: "Dr. Sami",
        at: "2026-08-11T09:20:00Z",
        resolved: false,
      },
    ],
    versions: [
      {
        id: "v-i3-1", n: 1, status: "in_review" as const, at: "2026-08-11T09:00:00Z",
        actor: "Nour H.", title: "Women's health focus", subject: "موضوعات صحة المرأة",
        blocks: [], notes: "Submitted for editorial review.",
      },
    ],
  },
  {
    id: "i4", title: "Back to school — children's health", subject: "العودة للمدارس: نصائح للأمهات",
    status: "draft" as const, updated_at: "2026-08-11T15:20:00Z", author: "Lina A.", articles: 2, open_rate: null,
    articles_list: [
      { title: "فوائد فيتامين D للأطفال", url: "https://altibbi.com/مقالات-طبية/", category: "Pediatrics" },
    ],
    notes: "Draft — needs 2 more articles before review.",
    next_action: "Add 2 more articles",
  },
];

export const DEMO_CAMPAIGNS = [
  { id: "c1", name: "Weekly digest — 4 Aug", issue_title: "Weekly health digest", segment_name: "Weekly digest — opted in", status: "sent" as const, scheduled_at: "2026-08-04T08:00:00Z", sent_at: "2026-08-04T08:05:00Z", recipients: 184_102, open_rate: 24.2, delivered: 184_102 },
  { id: "c2", name: "Gulf digest — 28 Jul", issue_title: "Gulf health roundup", segment_name: "Gulf — Arabic digest", status: "sent" as const, scheduled_at: "2026-07-28T08:00:00Z", sent_at: "2026-07-28T08:02:00Z", recipients: 66_891, open_rate: 21.8, delivered: 66_891 },
  { id: "c3", name: "Summer skincare — scheduled", issue_title: "صيف 2026 — نصائح الترطيب", segment_name: "Weekly digest — opted in", status: "scheduled" as const, scheduled_at: "2026-08-27T15:00:00Z", sent_at: null as string | null, recipients: 186_204, open_rate: null },
  { id: "c4", name: "Nutrition — Jordan live send", issue_title: "5 Foods That May Help Lower Cholesterol", segment_name: "Nutrition — Jordan", status: "sending" as const, scheduled_at: "2026-08-26T07:00:00Z", sent_at: null, recipients: 84_231, open_rate: null, delivered: 42_182 },
];

export const DEMO_ARTICLE_LINKS = [
  { title: "استخدامات بودرة التلك وأضرارها", url: "https://altibbi.com/مقالات-طبية/كيمياء/بودرة-التلك-استخدامات-بودرة-التلك-ومضارها-4849", category: "Dermatology" },
  { title: "فوائد فيتامين D للأطفال", url: "https://altibbi.com/مقالات-طبية/", category: "Pediatrics" },
  { title: "أعراض نقص الحديد عند النساء", url: "https://altibbi.com/مقالات-طبية/", category: "Women's health" },
  { title: "حماية البشرة من أشعة الشمس", url: "https://altibbi.com/مقالات-طبية/", category: "Dermatology" },
  { title: "التحضير للحمل", url: "https://altibbi.com/مقالات-طبية/", category: "Pregnancy" },
];

export function filterDemoSubscribers(q: string, limit: number) {
  const needle = q.toLowerCase();
  let rows = DEMO_SUBSCRIBERS;
  if (needle) {
    rows = rows.filter(
      (s) =>
        s.email?.toLowerCase().includes(needle) ||
        s.clevertap_identity?.toLowerCase().includes(needle) ||
        s.country?.toLowerCase().includes(needle),
    );
  }
  return rows.slice(0, limit);
}

const delay = (ms: number) => new Promise((r) => setTimeout(r, ms));

export async function demoFetch<T>(data: T, ms = 280): Promise<T> {
  await delay(ms);
  return data;
}
